/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EntityPartner } from '../models';
// @ts-ignore
import type { InputCreateEntityPartner } from '../models';
/**
 * AdminEntityPartnerApi - axios parameter creator
 * @export
 */
export const AdminEntityPartnerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get requested entity partners
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allEntityPartners: async (filter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/entityPartner/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"create\", \"EntityPartner\"] 
         * @summary Create entity partner
         * @param {InputCreateEntityPartner} [inputCreateEntityPartner] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityPartner: async (inputCreateEntityPartner?: InputCreateEntityPartner, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/entityPartner/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputCreateEntityPartner, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"update\", \"EntityPartner\"] 
         * @summary edit an entity partner
         * @param {number} id 
         * @param {InputCreateEntityPartner} [inputCreateEntityPartner] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editEntityPartner: async (id: number, inputCreateEntityPartner?: InputCreateEntityPartner, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('editEntityPartner', 'id', id)
            const localVarPath = `/admin/entityPartner/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputCreateEntityPartner, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"readOne\", \"EntityPartner\"] 
         * @summary Get a single entity partner
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminEntityPartnerById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAdminEntityPartnerById', 'id', id)
            const localVarPath = `/admin/entityPartner/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminEntityPartnerApi - functional programming interface
 * @export
 */
export const AdminEntityPartnerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminEntityPartnerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get requested entity partners
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allEntityPartners(filter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityPartner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allEntityPartners(filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEntityPartnerApi.allEntityPartners']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"create\", \"EntityPartner\"] 
         * @summary Create entity partner
         * @param {InputCreateEntityPartner} [inputCreateEntityPartner] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityPartner(inputCreateEntityPartner?: InputCreateEntityPartner, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityPartner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityPartner(inputCreateEntityPartner, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEntityPartnerApi.createEntityPartner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"update\", \"EntityPartner\"] 
         * @summary edit an entity partner
         * @param {number} id 
         * @param {InputCreateEntityPartner} [inputCreateEntityPartner] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editEntityPartner(id: number, inputCreateEntityPartner?: InputCreateEntityPartner, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityPartner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editEntityPartner(id, inputCreateEntityPartner, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEntityPartnerApi.editEntityPartner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"readOne\", \"EntityPartner\"] 
         * @summary Get a single entity partner
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminEntityPartnerById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityPartner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminEntityPartnerById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEntityPartnerApi.getAdminEntityPartnerById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminEntityPartnerApi - factory interface
 * @export
 */
export const AdminEntityPartnerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminEntityPartnerApiFp(configuration)
    return {
        /**
         * 
         * @summary Get requested entity partners
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allEntityPartners(filter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityPartner>> {
            return localVarFp.allEntityPartners(filter, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"create\", \"EntityPartner\"] 
         * @summary Create entity partner
         * @param {InputCreateEntityPartner} [inputCreateEntityPartner] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityPartner(inputCreateEntityPartner?: InputCreateEntityPartner, options?: RawAxiosRequestConfig): AxiosPromise<EntityPartner> {
            return localVarFp.createEntityPartner(inputCreateEntityPartner, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"update\", \"EntityPartner\"] 
         * @summary edit an entity partner
         * @param {number} id 
         * @param {InputCreateEntityPartner} [inputCreateEntityPartner] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editEntityPartner(id: number, inputCreateEntityPartner?: InputCreateEntityPartner, options?: RawAxiosRequestConfig): AxiosPromise<EntityPartner> {
            return localVarFp.editEntityPartner(id, inputCreateEntityPartner, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"readOne\", \"EntityPartner\"] 
         * @summary Get a single entity partner
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminEntityPartnerById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<EntityPartner> {
            return localVarFp.getAdminEntityPartnerById(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminEntityPartnerApi - interface
 * @export
 * @interface AdminEntityPartnerApi
 */
export interface AdminEntityPartnerApiInterface {
    /**
     * 
     * @summary Get requested entity partners
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEntityPartnerApiInterface
     */
    allEntityPartners(filter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityPartner>>;

    /**
     *  **Permission required**: [\"create\", \"EntityPartner\"] 
     * @summary Create entity partner
     * @param {InputCreateEntityPartner} [inputCreateEntityPartner] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEntityPartnerApiInterface
     */
    createEntityPartner(inputCreateEntityPartner?: InputCreateEntityPartner, options?: RawAxiosRequestConfig): AxiosPromise<EntityPartner>;

    /**
     *  **Permission required**: [\"update\", \"EntityPartner\"] 
     * @summary edit an entity partner
     * @param {number} id 
     * @param {InputCreateEntityPartner} [inputCreateEntityPartner] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEntityPartnerApiInterface
     */
    editEntityPartner(id: number, inputCreateEntityPartner?: InputCreateEntityPartner, options?: RawAxiosRequestConfig): AxiosPromise<EntityPartner>;

    /**
     *  **Permission required**: [\"readOne\", \"EntityPartner\"] 
     * @summary Get a single entity partner
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEntityPartnerApiInterface
     */
    getAdminEntityPartnerById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<EntityPartner>;

}

/**
 * AdminEntityPartnerApi - object-oriented interface
 * @export
 * @class AdminEntityPartnerApi
 * @extends {BaseAPI}
 */
export class AdminEntityPartnerApi extends BaseAPI implements AdminEntityPartnerApiInterface {
    /**
     * 
     * @summary Get requested entity partners
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEntityPartnerApi
     */
    public allEntityPartners(filter?: string, options?: RawAxiosRequestConfig) {
        return AdminEntityPartnerApiFp(this.configuration).allEntityPartners(filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"create\", \"EntityPartner\"] 
     * @summary Create entity partner
     * @param {InputCreateEntityPartner} [inputCreateEntityPartner] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEntityPartnerApi
     */
    public createEntityPartner(inputCreateEntityPartner?: InputCreateEntityPartner, options?: RawAxiosRequestConfig) {
        return AdminEntityPartnerApiFp(this.configuration).createEntityPartner(inputCreateEntityPartner, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"update\", \"EntityPartner\"] 
     * @summary edit an entity partner
     * @param {number} id 
     * @param {InputCreateEntityPartner} [inputCreateEntityPartner] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEntityPartnerApi
     */
    public editEntityPartner(id: number, inputCreateEntityPartner?: InputCreateEntityPartner, options?: RawAxiosRequestConfig) {
        return AdminEntityPartnerApiFp(this.configuration).editEntityPartner(id, inputCreateEntityPartner, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"readOne\", \"EntityPartner\"] 
     * @summary Get a single entity partner
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEntityPartnerApi
     */
    public getAdminEntityPartnerById(id: number, options?: RawAxiosRequestConfig) {
        return AdminEntityPartnerApiFp(this.configuration).getAdminEntityPartnerById(id, options).then((request) => request(this.axios, this.basePath));
    }
}

